import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";
import { SettingsSectionWrapper } from "~/components/settings/SettingsSection";
import { formatBatchConfigurationDisplay } from "~/features/preview/batches/batchSettings.utils";
import { OverviewFieldRow } from "~/features/settings/components/OverviewFieldRow";
import { selectUsersFulfillmentCenter } from "~/redux/selectors/storeSelectors";

export function BatchesOverviewSection() {
  const { t } = useTranslation();
  const userFc = useAppSelector(selectUsersFulfillmentCenter);

  return (
    <SettingsSectionWrapper title={t("overview")}>
      <Stack spacing={2.5} sx={{ width: "100%" }}>
        <OverviewFieldRow
          label={t("batch configuration")}
          helperText={t("total # of bins in grid")}
        >
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {formatBatchConfigurationDisplay(userFc?.batchConfiguration, t)}
          </Typography>
        </OverviewFieldRow>

        <OverviewFieldRow label={t("time zone")}>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {userFc?.timeZone}
          </Typography>
        </OverviewFieldRow>
      </Stack>
    </SettingsSectionWrapper>
  );
}
